export default "__VITE_ASSET__BLBFKpqf__"